import './Column.css'

const Column = ({ children, lg }) => {
  return (
    <div className={`column lg${lg}`}>{children}</div>
  )
}

export default Column
